// eslint-disable-next-line import/prefer-default-export
export function getRandomValue() {
  return Math.floor(Math.random() * 99999999);
}



// WEBPACK FOOTER //
// ./src/lib/auth.utils.js